// KAMPFSPORT KIDS READY™ — German copy of MARTIAL ARTS KIDS CLASS READY™ (the winner). Same structure, palette and angles.
// All copy and links live here. Image URLs live in data/images.ts, the pixel in data/pixel.ts.
// Market: Germany, Austria, Switzerland (DACH market in the store: fixed EUR prices).
// Promise (must match ads, checkout and the PDF): 52-week plan + 10 complete 45-minute kids classes,
// 27 € one-time, 10-day guarantee, the 5 bonuses in the checkout order.
// Values = the checkout: main 159 €; bonuses 37, 27, 27, 27, 37 € (155 €); total 314 € -> 27 €, you save 287 €.
// Game, drill, quarter and page names match the German Gamma book (doc is79hp6htemg9ko).
// Kids + contact sport: no promises about self-defense, belts or sign-ups; pads and air only, no sparring; no testimonials.
// ­ = soft hyphen, so long German words can break on a 375 px screen.

export { META_PIXEL_ID } from './pixel';
export const CHECKOUT_URL = 'https://kampfsport-kids-ready.impultienda.ar/checkout';

export const PAGE_TITLE = 'Kampfsport Kids Ready™ | Dein ganzes Jahr Kindertraining, fertig geplant';
export const META_DESCRIPTION =
  'Ein 52-Wochen-Plan plus 10 komplette, sofort einsetzbare 45-Minuten-Trainings für Kinder. Seite der Woche aufschlagen, 5 Minuten vorbereiten und noch heute unterrichten.';

// GLOBAL
export const brand = 'KAMPFSPORT KIDS READY™';
/** Label for every button that scrolls to the offer section */
export const ctaLabel = 'MEIN GANZES JAHR PLANEN';
export const ctaMicrocopy = 'Sofort als PDF · Einmalig 27 € · 10 Tage Garantie';
export const stickyLabel = 'MEIN JAHR PLANEN · 27 €';
export const topBarMobileLabel = 'DAS BUCH · 27 €';
export const price = '27 €';

// 1. HERO (buyer line, title, short subtitle, mockup, button)
export const hero = {
  eyebrow: 'FÜR KARATE-, TAEKWONDO-, KICKBOX- UND MUAY-THAI-TRAINER',
  titleLead: 'DEIN GANZES JAHR KINDER­TRAINING,',
  titleHighlight: 'FERTIG GEPLANT.',
  sub: 'Ein 52-Wochen-Plan plus 10 komplette, sofort einsetzbare 45-Minuten-Trainings für Kinder. Schlag die Seite der Woche auf und unterrichte noch heute.',
  mockupAlt: 'Kampfsport Kids Ready™ auf einem Computerbildschirm, mit den 5 Boni auf Tablets und Smartphones',
};

// 2. STATS
export const stats = [
  { value: '52', label: 'WOCHEN GEPLANT' },
  { value: '10', label: 'KOMPLETTE TRAININGS' },
  { value: '45', label: 'MINUTEN MIT ZEITPLAN' },
  { value: '3', label: 'ALTERSSTUFEN IN JEDEM TRAINING' },
];

// 2b. BEFORE / AFTER
export const beforeAfter = {
  title: 'DER ABEND DAVOR VS. AUF DER MATTE.',
  before: {
    label: 'VORHER',
    when: 'Am Abend davor',
    quote: '„Was trainiere ich heute mit den Kids?“',
    items: ['Übungen in Videos zusammensuchen.', 'Wieder dieselbe Schlagübung.', 'Die Kleinen überfordert, die Großen gelangweilt.'],
  },
  after: {
    label: 'NACHHER',
    when: 'Auf der Matte',
    items: ['Seite der Woche aufschlagen.', 'In 5 Minuten vorbereiten.', 'Den 45-Minuten-Ablauf unterrichten.', 'Abgrüßen und die Eltern-Info verschicken.'],
  },
};

// 3. WHAT DOES YOUR CLASS NEED THIS WEEK (pick a need, see the class that is ready for it)
const block = 'Ablauf: Angrüßen & Aufwärmspiel 8 · Technik 12 · Pratzen & Partner 12 · Abschlussspiel 8 · Werte-Runde 5';
export const selector = {
  eyebrow: 'FANG DA AN, WO DEINE KIDS STEHEN',
  title: 'WAS BRAUCHT DEIN TRAINING DIESE WOCHE?',
  sub: 'Wähl ein Thema und sieh dir das Training an, das dafür schon fertig ist.',
  startLabel: 'DEIN NÄCHSTES TRAINING',
  tablistLabel: 'Trainingsthemen',
  columns: ['SEITE 1 · TRAININGSPLAN', 'SEITE 2 · SO ERKLÄRST DU ES', 'SEITE 3 · ÜBUNGEN & SPIEL'],
  note: 'Alle 10 Trainings haben denselben Aufbau auf 3 Seiten. Pass jedes an deinen Stil und die Sicherheitsregeln deiner Schule an.',
  items: [
    {
      tab: 'Ein starker Start: Stand & Respekt',
      n: 'TRAINING 01 · WOCHE 1',
      title: 'Stand, Deckung & Respekt im Dojo',
      goal: 'Das Kind grüßt an, steht in einer stabilen Kampfstellung mit hoher Deckung und geht auf Kommando zurück in die Bereitschaftsstellung.',
      open: ['Trainingsziel, Material und 5 Minuten Vorbereitung', 'Deine ersten Worte: „Füße auseinander, ein Fuß nach hinten. Hände hoch ans Gesicht. Das ist deine Deckung!“', block],
      activity: ['5 Technikschritte mit den wichtigen Punkten: Achtungsstellung, Verbeugung, Bereitschaftsstellung, Kampfstellung, Deckung', '3 Korrektur-Hinweise, zum Beispiel „Schienen, kein Drahtseil!“', 'Altersstufen-Karte: so klappt es mit 4–6, 7–9 und 10–12 Jahren'],
      close: ['2 Übungen mit Mattenplan: Stellungs-Kontrolle und Federn & Einfrieren', 'Abschlussspiel: Dojo sagt', 'Werte-Runde (Respekt), Eltern-Info und Streifen-Check'],
    },
    {
      tab: 'Tritte mit Gleichgewicht',
      n: 'TRAINING 03 · WOCHE 9',
      title: 'Front-Kick & Gleichgewicht',
      goal: 'Das Kind hebt das Knie, tritt mit dem Fußballen nach vorn und setzt den Fuß kontrolliert in der Stellung ab.',
      open: ['Trainingsziel, Material und 5 Minuten Vorbereitung', 'Deine ersten Worte: „Knie hoch … Kick … Knie zurück … Fuß ab. Die Deckung bleibt oben!“', block],
      activity: ['Technikschritte mit den wichtigen Punkten, vom Knieheben bis zum Absetzen', '3 Korrektur-Hinweise für die häufigsten Fehler beim Treten', 'Altersstufen-Karte für 4–6, 7–9 und 10–12 Jahre'],
      close: ['2 Übungen am Schlagpolster, mit Mattenplan und Zeiten', 'Abschlussspiel: Ampel-Kicks', 'Werte-Runde (Selbstbeherrschung), Eltern-Info und Streifen-Check'],
    },
    {
      tab: 'Kombinationen an den Pratzen',
      n: 'TRAINING 06 · WOCHE 22',
      title: 'Schlag­kombinationen an den Pratzen',
      goal: 'Das Kind schlägt eine 3er-Kombination (Jab, Cross, Haken) an die Pratze und geht zurück in die Deckung.',
      open: ['Trainingsziel, Material und 5 Minuten Vorbereitung', 'Deine ersten Worte: „1 ist Jab, 2 ist Cross, 3 ist Haken. Bereit? 1-2-3 … Deckung!“', block],
      activity: ['Technikschritte für den Haken und die 1-2-3', 'Wie die Großen die Pratzen sicher für einen Partner halten', 'Altersstufen-Karte für 4–6, 7–9 und 10–12 Jahre'],
      close: ['2 Pratzenübungen mit Mattenplan, Runden und Zeiten', 'Abschlussspiel: Kombi-Kette', 'Werte-Runde (Teamgeist), Eltern-Info und Streifen-Check'],
    },
    {
      tab: 'Sicherheit & Befreiung aus Griffen',
      n: 'TRAINING 09 · WOCHE 35',
      title: 'Befreiung aus Griffen & Vorsicht bei Fremden',
      goal: 'Das Kind befreit sich aus einem sanften Handgelenksgriff, tritt zurück, setzt seine starke Stimme ein und weiß: zu einer Vertrauensperson laufen und Bescheid sagen.',
      open: ['Trainingsziel, Material und 5 Minuten Vorbereitung', 'Deine ersten Worte: befreien, zurücktreten, starke Stimme, zur Vertrauensperson laufen', block],
      activity: ['Einfache Befreiungsschritte, langsam und sanft geübt', 'Die Sicherheitsregeln: bei der Gruppe bleiben, die starke Stimme benutzen, einer Vertrauensperson Bescheid sagen', 'Altersstufen-Karte für 4–6, 7–9 und 10–12 Jahre'],
      close: ['2 ruhige Übungen mit Mattenplan', 'Abschlussspiel: Starke-Stimme-Staffel', 'Werte-Runde (Sicherheit), Eltern-Info und Streifen-Check'],
    },
  ],
};

// 4. LOOK INSIDE (real pages of the book, in the same order as pageImages in data/images.ts)
export const lookInside = {
  eyebrow: 'ECHTE SEITEN. SIEH DIR DAS FORMAT VOR DEM KAUF AN.',
  title: 'DAS LIEGT KÜNFTIG NEBEN DEINER MATTE.',
  sub: 'Öffne jede Seite in voller Größe: dein 52-Wochen-Plan, ein komplettes Training auf 3 Seiten, die Generalprobe für die Gürtelprüfung und dein Trainingsplaner.',
  hint: 'Wischen für mehr · Tippe auf eine Seite für die volle Größe',
  note: 'Das sind ausgewählte Seiten, nicht das ganze Buch.',
  captions: [
    'Dein 52-Wochen-Plan (1. Quartal)',
    'Training 01 · Trainingsplan',
    'Training 01 · So erklärst du es',
    'Training 01 · Übungen & Spiel',
    'Training 10 · Prüfungsstationen',
    'Trainingsplaner + Streifen-Übersicht',
  ],
};

// 5. THE SYSTEM
export const plan = {
  eyebrow: 'EIN SYSTEM FÜR JEDES TRAINING',
  title: 'DAS GANZE JAHR STEHT. DU GRÜSST AN UND LEGST LOS.',
  text: 'Jede Woche des Jahres ist geplant: der Start eines der 10 kompletten Trainings, ein fertiges 10-Minuten-Spiel oder eine Übung oder ein Streifen-Check. Jedes Training gibt dir auf 3 Seiten den Plan, die Technikschritte und die Übungen mit Spiel.',
  steps: [
    { title: 'AUFSCHLAGEN', text: 'Such diese Woche in deinem 52-Wochen-Plan.' },
    { title: 'VORBEREITEN', text: 'Seite lesen und die Matte in 5 Minuten aufbauen.' },
    { title: 'TRAINIEREN', text: 'Aufwärmspiel, eine Technik, Pratzen und Partner.' },
    { title: 'ABGRÜSSEN', text: 'Abschlussspiel, Werte-Runde und die Eltern-Info.' },
  ],
  featuresTitle: 'IN JEDEM KOMPLETTEN TRAINING',
  features: [
    { icon: 'goal', title: 'Ein klares Trainingsziel', text: 'Ein Satz dazu, was die Kinder können sollen, die Startwoche und was sie vorher brauchen.' },
    { icon: 'timer', title: 'Ein 45-Minuten-Ablauf', text: 'Angrüßen & Aufwärmspiel 8 · Technik 12 · Pratzen & Partner 12 · Abschlussspiel 8 · Werte-Runde 5.' },
    { icon: 'steps', title: 'Technikschritte + Korrektur-Hinweise', text: 'Nummerierte Schritte mit den wichtigen Punkten und genau dem Kommando, mit dem du die häufigsten Fehler korrigierst.' },
    { icon: 'questions', title: '4–6, 7–9 und 10–12 Jahre', text: 'So unterrichtest du dasselbe Training für jedes Alter auf deiner Matte, auch in gemischten Gruppen.' },
    { icon: 'quote', title: 'Deine Worte, Wort für Wort', text: 'Begrüßung, Kommandos und Werte-Runde, dazu ein Profi-Tipp und ein typischer Fehler.' },
    { icon: 'action', title: 'Übungen, Spiel + Eltern-Info', text: '2 Übungen und ein Abschlussspiel mit Mattenplan, ein Streifen-Check und eine Nachricht an die Eltern.' },
  ],
} as const;

// 5b. VALUES + AGE LEVELS
export const valuesBand = {
  eyebrow: 'MEHR ALS TRITTE UND SCHLÄGE',
  title: 'EIN WERT FÜR JEDES TRAINING. DAS GANZE JAHR.',
  sub: 'Jedes Training endet mit einer kurzen Werte-Runde, Wort für Wort, damit die Eltern sehen, was ihre Kinder mit nach Hause nehmen.',
  classWord: 'TRAINING',
  values: [
    { n: '01', value: 'Respekt' },
    { n: '02', value: 'Konzen­tration' },
    { n: '03', value: 'Selbst­beherrschung' },
    { n: '04', value: 'Durchhalte­vermögen' },
    { n: '05', value: 'Selbst­vertrauen' },
    { n: '06', value: 'Teamgeist' },
    { n: '07', value: 'Aufmerk­samkeit' },
    { n: '08', value: 'Mut' },
    { n: '09', value: 'Sicherheit' },
    { n: '10', value: 'Disziplin' },
  ],
  agesTitle: 'JEDES TRAINING PASST SICH DEN KINDERN VOR DIR AN',
  ages: [
    { age: '4–6 JAHRE', text: 'Bodenmarkierungen, Tiernamen, kurze Schritte zum Mitsprechen und viele Spiele.' },
    { age: '7–9 JAHRE', text: 'Die ganze Technik an den Pratzen des Trainers, Seitenwechsel auf Kommando.' },
    { age: '10–12 JAHRE', text: 'Mehr Tempo, Bewegung mit hoher Deckung, Pratzen für den Partner halten und beim Anleiten helfen.' },
  ],
};

// 6. THE 52-WEEK PLAN (quarter names as printed in the book)
export const yearPlan = {
  eyebrow: 'DEIN 52-WOCHEN-PLAN',
  title: 'DAS GANZE JAHR, WOCHE FÜR WOCHE GEPLANT.',
  sub: 'In den ★-Wochen startet ein neues Training. Die ◆-Wochen sind Streifen-Checks. In den Wochen dazwischen wartet ein fertiges 10-Minuten-Spiel oder eine Übung.',
  weekWord: 'WOCHE',
  quarters: [
    {
      q: 'Q1',
      weeks: 'WOCHEN 1–13',
      name: 'DIE BASIS LEGEN',
      full: [
        { week: '1', label: 'START TRAINING 01', title: 'Stand, Deckung & Respekt im Dojo' },
        { week: '5', label: 'START TRAINING 02', title: 'Gerade Schläge: Jab & Cross' },
        { week: '9', label: 'START TRAINING 03', title: 'Front-Kick & Gleichgewicht' },
        { week: '13', label: 'STREIFEN-CHECK', title: 'Fortschritt mit dem Planer prüfen', review: true },
      ],
      activities: '+ fertige 10-Minuten-Spiele und Übungen wie Deckungs-Statue, Aufstellung auf Zeit und Flamingo-Statue.',
    },
    {
      q: 'Q2',
      weeks: 'WOCHEN 14–26',
      name: 'SCHLAGEN & VERTEIDIGEN',
      full: [
        { week: '14', label: 'START TRAINING 04', title: 'Roundhouse-Kick' },
        { week: '18', label: 'START TRAINING 05', title: 'Blocks: hoch, mittel & tief' },
        { week: '22', label: 'START TRAINING 06', title: 'Schlag­kombinationen an den Pratzen' },
        { week: '26', label: 'STREIFEN-CHECK', title: 'Fortschritt mit dem Planer prüfen', review: true },
      ],
      activities: '+ fertige 10-Minuten-Spiele und Übungen wie Uhrzeiger, Regen-Block und Kombi-Ansage.',
    },
    {
      q: 'Q3',
      weeks: 'WOCHEN 27–39',
      name: 'BEWEGEN & SICHER BLEIBEN',
      full: [
        { week: '27', label: 'START TRAINING 07', title: 'Beinarbeit & Distanz' },
        { week: '31', label: 'START TRAINING 08', title: 'Sicher fallen' },
        { week: '35', label: 'START TRAINING 09', title: 'Befreiung aus Griffen & Vorsicht bei Fremden' },
        { week: '39', label: 'STREIFEN-CHECK', title: 'Fortschritt mit dem Planer prüfen', review: true },
      ],
      activities: '+ fertige 10-Minuten-Spiele und Übungen wie „Zu nah, zu weit“, Schaukelstuhl und Sichere Zone.',
    },
    {
      q: 'Q4',
      weeks: 'WOCHEN 40–52',
      name: 'ALLES ZUSAMMENBRINGEN',
      full: [
        { week: '40', label: 'START TRAINING 10', title: 'Generalprobe für die Gürtelprüfung' },
        { week: '52', label: 'STREIFEN-CHECK', title: 'Streifen-Check zum Jahresabschluss', review: true },
      ],
      activities: '+ fertige 10-Minuten-Spiele und Übungen wie Block-Meister, Bühne frei und Dojo-Staffel.',
    },
  ],
  toolsTitle: 'DAZU DEINE TRAINER-WERKZEUGE',
  tools: ['Wenn das Training schwierig wird: 8 Situationen, was du sagst und tust', 'Trainingsplaner + Streifen-Übersicht: jedes Training in 5 Minuten planen', 'Mattenkarte zum Hinlegen neben die Matte'],
};

// 7. THE 10 COMPLETE CLASSES
export const meetings = {
  eyebrow: 'DIE 10 KOMPLETTEN TRAININGS',
  title: 'ZEHN KINDERTRAININGS. SOFORT EINSETZBAR.',
  sub: 'Folge dem 52-Wochen-Plan oder starte mit dem Training, das deine Kinder gerade brauchen. Jedes hat 3 Seiten: Trainingsplan, So erklärst du es, Übungen & Spiel.',
  weekLabel: 'STARTWOCHE',
  items: [
    { n: '01', week: '1', title: 'Stand, Deckung & Respekt im Dojo', goal: 'Angrüßen, eine stabile Kampfstellung mit hoher Deckung und die Bereitschaftsstellung auf Kommando.' },
    { n: '02', week: '5', title: 'Gerade Schläge: Jab & Cross', goal: 'Jab und Cross aus der Deckung, die Hand kommt jedes Mal zurück ans Gesicht.' },
    { n: '03', week: '9', title: 'Front-Kick & Gleichgewicht', goal: 'Knie hoch, mit dem Fußballen treten und kontrolliert in der Stellung landen.' },
    { n: '04', week: '14', title: 'Roundhouse-Kick', goal: 'Standfuß eindrehen, Knie seitlich hoch und kontrolliert auf ein tiefes oder mittleres Ziel kicken.' },
    { n: '05', week: '18', title: 'Blocks: hoch, mittel & tief', goal: 'Drei Blocks auf Kommando, den Blick beim Trainer.' },
    { n: '06', week: '22', title: 'Schlag­kombinationen an den Pratzen', goal: 'Eine 3er-Kombination (Jab, Cross, Haken) an die Pratze und zurück in die Deckung.' },
    { n: '07', week: '27', title: 'Beinarbeit & Distanz', goal: 'Vorwärts, rückwärts und seitwärts bewegen, ohne die Füße zu kreuzen, und die richtige Distanz finden.' },
    { n: '08', week: '31', title: 'Sicher fallen', goal: 'Aus tiefer Position nach hinten und zur Seite fallen, Kinn zur Brust, und sicher aufstehen.' },
    { n: '09', week: '35', title: 'Befreiung aus Griffen & Vorsicht bei Fremden', goal: 'Aus einem sanften Handgelenksgriff befreien, die starke Stimme einsetzen und zu einer Vertrauensperson laufen.' },
    { n: '10', week: '40', title: 'Generalprobe für die Gürtelprüfung', goal: 'Eine ruhige Probe-Gürtelprüfung mit den Techniken des Jahres, Bewertungsbogen und Ablauf für die Zeremonie.' },
  ],
  cta: 'ALLE 10 TRAININGS + 5 BONI HOLEN',
  ctaMicrocopy: '27 € · Einmalige Zahlung',
};

// 8. BONUSES (same order and values as the checkout)
export const bonuses = {
  eyebrow: '5 BONI INKLUSIVE IN DEINEM BUCH FÜR 27 €',
  title: 'ALLES, WAS DEIN KINDERTRAINING SONST NOCH BRAUCHT.',
  sub: 'Spiele, Gürtelprüfungen, Elternnachrichten, Pratzenübungen und ein Plan fürs Probetraining, sofort einsetzbar.',
  valueWord: 'WERT',
  free: 'GRATIS',
  coverWord: 'Cover',
  totalNote: '155 € an Boni, gratis dabei',
  items: [
    {
      label: 'BONUS 01',
      value: '37 €',
      short: '60 Kampfsport-Spiele für Kinder',
      hook: 'Nie wieder ohne Spielideen.',
      title: '60 Kampfsport-Spiele für Kinder – ganz ohne Material',
      text: '60 lustige, sichere Spiele zum Einstieg, zum Auspowern und zum Abschluss jedes Trainings, sortiert nach Ziel: Aufwärmen, Reaktion, Gleichgewicht, Konzentration, Treten und Schlagen, Teamgeist und Cool-down. Jedes mit Aufbau, Regeln, Dauer und Sicherheitstipp.',
    },
    {
      label: 'BONUS 02',
      value: '27 €',
      short: 'Gürtelprüfungs-Kit',
      hook: 'Ruhige, gut organisierte Gürtelprüfungen.',
      title: 'Gürtelprüfungs-Kit – Anforderungen, Ablaufplan & Urkunden zum Ausdrucken',
      text: 'Eine Beispiel-Checkliste mit Anforderungen für jeden Gürtel (an deinen Stil anpassbar), ein Bewertungsbogen, ein Ablaufplan mit Zeiten, was du zur Eröffnung und zum Abschluss sagst, ein Streifen-Tracker und Urkunden zum Ausdrucken.',
    },
    {
      label: 'BONUS 03',
      value: '27 €',
      short: 'Eltern-Kommunikationspaket',
      hook: 'Du weißt genau, was du den Familien schickst.',
      title: 'Eltern-Kommunikations­paket – Willkommensbrief, Dojo-Regeln & fertige Nachrichten',
      text: 'Ein Willkommensbrief für neue Kinder, Dojo-Regeln für Kinder auf einer Seite, eine Checkliste „Was bringe ich mit?“, Ankündigungen für Gürtelprüfungen, eine monatliche Werte-Info, Nachrichten bei verpassten Trainings und Leitfäden für ruhige Elterngespräche.',
    },
    {
      label: 'BONUS 04',
      value: '27 €',
      short: '50 Pratzen- & Partnerübungen',
      hook: 'Frische Pratzenarbeit für jedes Training.',
      title: '50 Pratzen- & Partnerübungen – für jedes Kindertraining',
      text: '50 Übungen mit Pratzen, Schlagpolstern und Partnern für Schläge, Tritte, Blocks, Kombinationen, Beinarbeit und Reaktion. Jede mit Aufbau, Runden und Zeiten, der richtigen Pratzenhaltung und einem Sicherheitshinweis.',
    },
    {
      label: 'BONUS 05',
      value: '37 €',
      short: 'Der Probetraining-Leitfaden',
      hook: 'Damit jedes erste Training zählt.',
      title: 'Der Probetraining-Leitfaden – ein erstes Training, das Kinder und Eltern begeistert',
      text: 'Wie du die Familie an der Tür begrüßt, ein 30-Minuten-Probetraining mit Spielen und einer ersten Technik, die jedes Kind schafft, was du am Ende sagst und fertige Nachrichten für die Tage danach.',
    },
  ],
};

// 9. OFFER
export const offer = {
  eyebrow: 'DEIN NÄCHSTES TRAINING BEGINNT HIER',
  title: 'DEIN GANZES JAHR KINDERTRAINING. IN EINEM BUCH.',
  kicker: 'DAS KOMPLETTE DIGITALE BUCH',
  name: 'Kampfsport Kids Ready™',
  description: 'Ein 52-Wochen-Plan und 10 komplette, sofort einsetzbare 45-Minuten-Kindertrainings, dazu fünf Boni: Spiele, ein Gürtelprüfungs-Kit, Elternnachrichten, Pratzenübungen und ein Leitfaden fürs Probetraining.',
  mockupAlt: 'Alles, was in Kampfsport Kids Ready™ enthalten ist',
  includedTitle: 'DEIN BUCH ENTHÄLT',
  included: [
    '52-Wochen-Plan: das ganze Jahr geplant',
    '10 komplette Kindertrainings mit je 3 Seiten',
    'Einen 45-Minuten-Ablauf mit Zeiten in jedem Training',
    'Technikschritte, wichtige Punkte und Korrektur-Hinweise',
    '4–6, 7–9 und 10–12 Jahre in jedem Training',
    'Übungen, Abschlussspiel, Werte-Runde und Eltern-Info',
    'Trainer-Werkzeuge: schwierige Momente, Planer, Mattenkarte',
  ],
  /** Value stack: exactly the checkout prices (DACH market) */
  stackTitle: 'DAS BEKOMMST DU ALLES',
  mainItem: { label: 'Kampfsport Kids Ready™ (52-Wochen-Plan + 10 komplette Trainings)', value: '159 €' },
  totalLabel: 'Gesamtwert',
  totalValue: '314 €',
  todayLabel: 'HEUTE',
  priceNote: 'Einmalige Zahlung · Rund 52 Cent pro Woche',
  saveNote: 'Du sparst 287 €',
  /** The ONLY button that goes to checkout */
  cta: 'JA, SCHICK MIR DAS BUCH – 27 €',
  ctaNote: ['Weiter zur sicheren Kasse', 'Zugang per E-Mail nach der Zahlung'],
  format: 'PDF auf Deutsch. Digitale Lieferung. Pass jedes Training an deinen Stil, die Sicherheitsregeln deiner Schule und das Alter und Niveau deiner Kinder an.',
  guaranteeNote: '10 Tage Geld-zurück-Garantie',
};

// 10. GUARANTEE
export const guarantee = {
  sealTop: '10',
  sealBottom: 'TAGE GELD ZURÜCK',
  title: '10 TAGE GELD ZURÜCK. OHNE WENN UND ABER.',
  text: 'Unterrichte deine nächsten Trainings damit. Wenn es nicht das Richtige für dich ist, schreib innerhalb von 10 Tagen nach dem Kauf an support@stockdigital.shop und du bekommst dein Geld zurück.',
};

// 11. FAQ
export const faq = {
  eyebrow: 'DU WEISST GENAU, WAS DU BEKOMMST',
  title: 'EIN PAAR FRAGEN, BEVOR DU ANGRÜSST.',
  sub: 'Gemacht für Trainer und Schulinhaber, die Kinder unterrichten. Ein fertiges Trainingsbuch, kein Videokurs.',
  items: [
    {
      q: 'Was genau ist dieses Produkt?',
      a: 'Ein PDF-Buch auf Deutsch: ein 52-Wochen-Plan (jede Woche hat den Start eines Trainings, ein fertiges 10-Minuten-Spiel oder eine Übung oder einen Streifen-Check) und 10 komplette 45-Minuten-Kindertrainings mit je 3 Seiten, dazu Trainer-Werkzeuge und 5 Boni.',
    },
    {
      q: 'Für welche Stile passt es?',
      a: 'Für Schlag- und Trittstile, die Kindern beigebracht werden: Karate, Taekwondo, Kickboxen, Muay Thai und gemischte Programme. Die Techniken tragen allgemeine Namen (Front-Kick, Jab, hoher Block), und jedes Training erinnert dich daran, die Namen, die Etikette und die Gürtelfolge deines Stils zu verwenden.',
    },
    {
      q: 'Für welches Alter ist es?',
      a: 'Für Kinder von etwa 4 bis 12 Jahren. Jedes Training hat eine Altersstufen-Karte für 4–6, 7–9 und 10–12 Jahre, damit es auch in gemischten Gruppen funktioniert.',
    },
    {
      q: 'Gibt es Sparring oder Kontakt?',
      a: 'Kein Sparring. Die Kinder schlagen und treten auf Pratzen, Ziele und in die Luft. Partnerübungen nur mit leichtem, kontrolliertem Kontakt auf Pratzen und immer unter Aufsicht. Fallen wird nur auf Matten und aus tiefer Position geübt.',
    },
    {
      q: 'Lernen die Kinder im Sicherheitstraining Selbstverteidigung?',
      a: 'Training 09 zeigt einfache, sanfte Befreiungen aus Griffen und Sicherheitsregeln: bei der Gruppe bleiben, eine starke Stimme einsetzen und einer Vertrauensperson Bescheid sagen. Es ist kein Versprechen, dass sich ein Kind in jeder Situation verteidigen kann.',
    },
    {
      q: 'Wie bekomme ich es?',
      a: 'Nach der Zahlung bekommst du den Zugang an die E-Mail-Adresse, die du an der Kasse angibst. Es wird nichts verschickt. Nutze eine E-Mail, auf die du Zugriff hast, und schau notfalls im Spam-Ordner nach.',
    },
    {
      q: 'Kann ich die Trainings einzeln nutzen?',
      a: 'Ja. Jedes Training funktioniert für sich: Du kannst mit dem starten, das deine Kinder gerade brauchen, oder dem 52-Wochen-Plan ab Woche 1 folgen.',
    },
    {
      q: 'Kann ich es ausdrucken?',
      a: 'Ja. Die Seiten lassen sich gut auf dem Handy oder Tablet neben der Matte lesen, und Trainingsplaner und Streifen-Übersicht sind fertig zum Ausdrucken.',
    },
    {
      q: 'Darf ich es mit meinen Trainern teilen?',
      a: 'Dieser Kauf ist für deine eigene Nutzung als Trainer. Die Weitergabe an mehrere Schulen, die Verbreitung oder der Weiterverkauf sind in diesem Angebot nicht enthalten.',
    },
    { q: 'Ist das ein Abo?', a: 'Nein. Eine einmalige Zahlung von 27 €.' },
    { q: 'Wie funktioniert die Garantie?', a: 'Du hast 10 Tage Zeit, dein Geld zurückzuverlangen, ohne Wenn und Aber.' },
  ],
};

// 12. FINAL CTA
export const finalCta = {
  eyebrow: 'FÜR DAS NÄCHSTE „WAS TRAINIERE ICH HEUTE MIT DEN KIDS?“',
  title: 'GEH HEUTE MIT EINEM FERTIGEN TRAINING AUF DIE MATTE.',
  text: 'Seite der Woche aufschlagen. 5 Minuten vorbereiten. Ein Training geben, zu dem die Kinder wiederkommen wollen.',
  microcopy: '52-Wochen-Plan + 10 komplette Trainings + 5 Boni · 27 €, einmalige Zahlung',
};

// 13. FOOTER
export const footer = {
  line: 'KAMPFSPORT KIDS READY™ · Trainingsmaterial für Trainer. Halte dich immer an die Regeln deines Stils und die Sicherheitsvorgaben deiner Schule.',
  supportLabel: 'Support:',
  supportEmail: 'support@stockdigital.shop',
  copyright: '© 2026',
};
